import { Article } from 't2-graphql-types';
import isEqual from 'lodash/isEqual';
import intersectionWith from 'lodash/intersectionWith';
import pickFp from 'lodash/fp/pick';
import { useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { TArticleBody } from '../../ArticleBodyRenderer/types';
import { TArticleHighlight } from '../types';
import { getTopQuoteReplyQuery } from '../queries/getTopQuoteReplyQuery';
import { getFeatureFlag } from '../../FeatureFlags/getFeatureFlag';

const getValidHighlightData = (body: TArticleBody, highlightData: TArticleHighlight): TArticleHighlight | undefined => {
  const bodyIdsAndType = body?.blocks?.map(pickFp(['id', 'type']));
  const highlightDataIdsAndType = highlightData?.blocks?.map(pickFp(['id', 'type']));
  if (!isEqual(intersectionWith(bodyIdsAndType, highlightDataIdsAndType, isEqual), highlightDataIdsAndType)) {
    return undefined;
  }

  return highlightData;
};

export const useTopQuoteReply = (
  articleId: Article['id'],
  body: TArticleBody,
): [Article | undefined, TArticleHighlight | undefined] => {
  if (!getFeatureFlag('replyToQuote')) {
    return [undefined, undefined];
  }
  const [getTopQuoteReplyQueryRequest, { data }] = useLazyQuery(getTopQuoteReplyQuery, {
    variables: {
      articleId,
    },
  });

  useEffect(() => {
    getTopQuoteReplyQueryRequest({ variables: { articleId } });
  }, [articleId]);

  const quote = data?.article?.sortedChildArticles?.[0];
  if (!quote) {
    return [undefined, undefined];
  }

  return [quote, getValidHighlightData(body, quote.body)];
};
